import actions from './actions'
import crudReducers from '../../crud/reducers'

const dataPropName = 'visit'

const initState = {
  list: [],
  listLoaded: false,
  loading: false,
  loaded: false,
  error: false,
  modalActive: false,
  visit: {}
}

const reducers = crudReducers(actions, dataPropName, initState)

export default reducers
